module.exports = __webpack_public_path__ + "img/20190702162216173.ce0bb59a.png";